import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import { technologyInfo } from "../assets/templates-info";
import firebaseDb from "../main";

import {
  SET_SELECTED_TECHNOLOGY,
  SET_SELECTED_ARCHITECTURE,
  CLEAR_SELECTED_TECHNOLOGY,
  CLEAR_SELECTED_ARCHITECTURE,
  SET_SELECTED_APP,
  CLEAR_SELECTED_APP,
  REMOVE_APP,
  SET_APPS,
  SET_VIEWS,
  CLEAR_VIEWS,
  SET_FOOTER_STATE,
  ADD_VIEW,
  SET_ADDED_VIEWTYPE,
  RESET_VIEWS_START,
  SET_USER,
  SET_NAVIGATION_BAR_STATE
} from "./mutation-types";

/**
 * navigationBarState
 *
 * 0 - Not logged in
 * 1 - Logged in
 * 2 - Show no items on right side
 */

Vue.use(Vuex);

// var apiEndpoint =
//   "http://localhost:5000/appskeletons/us-central1/appskeletonsapi";
var apiEndpoint =
  "https://us-central1-appskeletons.cloudfunctions.net/appskeletonsapi";

export default new Vuex.Store({
  state: {
    footerState: 1,
    navigationBarState: 2,
    userVerified: false,
    appDownloadLink: "",
    appPackageName: "",
    views: [],
    selectedView: {},
    selectedApp: null,
    addedViewType: "",
    apps: [],
    resendingVerificationEmail: false,
    architectures: [
      {
        name: "ScopedModel",
        description:
          "ScopedModel is a set of utilities that was pulled directly out of the Fuchia (Google's new OS) repository. These utilites were made into a library for Flutter.\n\nIt's created for a simpler architecture than Redux or BLoC, but more sophisticated than the basic setState.",
        recommendation: "Recommended for small to medium apps",
        value: "scoped_model_model_per_view",
        selected: false,
        available: true,
        views: [
          {
            title: "Empty",
            description: "Empty view with no UI widgets.",
            type: "empty"
          },
          {
            title: "Login",
            description:
              "Contains UI that allows the user to input login details. It handles showing errors a busy indication.",
            fixedName: true,
            suggestedName: "Login",
            onlyOneAllowed: true,
            type: "login"
          },
          {
            title: "Sign Up",
            description:
              "Contains UI that allows the user to sign up. It handles showing errors a busy indication.",
            fixedName: true,
            suggestedName: "SignUp",
            onlyOneAllowed: true,
            type: "signup"
          },
          {
            title: "List",
            description:
              "A view with a fullscreen List widget. It contains pull to refresh and basic model binding.",
            type: "list"
          }
        ]
      },
      {
        name: "BLoC",
        description:
          "A state management system for Flutter recommended by Google developers. Logic is divided into Components that exposes a stream of states which the UI can bind to.",
        recommendation: "Recommended for small to medium apps",
        value: "bloc_arc",
        selected: false,
        available: false,
        views: [
          {
            title: "Empty",
            description: "Empty view with no UI widgets.",
            type: "empty"
          },
          {
            title: "Login",
            description:
              "Contains UI to allow user to input login details. It is bound to an authentication function and handles showing errors and busy indicator.",
            fixedName: true,
            suggestedName: "Login",
            onlyOneAllowed: true,
            type: "login",
            available: false
          },
          {
            title: "Sign Up",
            description:
              "A view with a basic UI that will allow the user to input registration details. It handles showing errors and busy indicator.",
            fixedName: true,
            suggestedName: "SignUp",
            onlyOneAllowed: true,
            type: "signup",
            available: false
          },
          {
            title: "List",
            description:
              "A view with a List widget added sized to fit the entire screen. It contains pull to refresh and also binds the list to a results model.",
            type: "list",
            available: false
          }
        ]
      },
      {
        name: "Redux",
        description:
          "Redux helps you write applications that behave consistently, run in different environments (client, server, and native), and are easy to test.",
        recommendation: "Recommended for small to medium apps",
        value: "scoped_model_model_per_view",
        selected: false,
        available: false
      }
    ],
    selectedTechnology: {},
    selectedArchitecture: {},
    technologies: technologyInfo.technologies
  },
  getters: {
    /* Information getters */
    hasSelectedTechnology(state) {
      return state.selectedTechnology !== {};
    },
    hasSelectedArchitecture(state) {
      return state.selectedArchitecture !== {};
    },
    getSelectedTechnologyName(state) {
      return state.selectedTechnology.name;
    },
    getSelectedArchitectureName(state) {
      return state.selectedArchitecture.name;
    },
    getSelectedArchitectureValue(state) {
      return state.selectedArchitecture.value;
    },
    getSelectedArchitectureViews(state) {
      return state.selectedArchitecture.views;
    },
    isTechnologySelected: state => technology => {
      return state.selectedTechnology === technology;
    },
    isArchitectureSelected: state => architecture => {
      return state.selectedArchitecture === architecture;
    },
    getArchitectureFromValue: state => templateName => {
      return state.architectures.filter(architecture => {
        return architecture.value == templateName;
      });
    },
    getTechnologyFromValue: state => templateName => {
      if (templateName === "bloc_arc") {
        /* When we have more than one technology map architecture name to the tech here */
      }
      return state.technologies[0];
    },
    /* -------------------- */

    /* Template building getters */
    hasTemplateViews: state => {
      return state.views.length > 0;
    },
    /* --------------------- */

    isSelectedView: state => view => {
      return state.selectedView.name === view.name;
    },
    hasSelectedApp(state) {
      return state.selectedApp != null;
    },
    isAppSelected: state => app => {
      return state.selectedApp === app;
    }
  },
  mutations: {
    /* Information mutations */
    [SET_SELECTED_TECHNOLOGY]: (state, technology) => {
      state.selectedTechnology = technology;
    },
    [SET_SELECTED_ARCHITECTURE]: (state, architecture) => {
      state.selectedArchitecture = architecture;
    },
    [CLEAR_SELECTED_TECHNOLOGY]: state => {
      state.selectedTechnology = {};
    },
    [CLEAR_SELECTED_ARCHITECTURE]: state => {
      state.selectedArchitecture = {};
    },
    /* --------------------- */

    /* Dashboard app selection */
    [SET_SELECTED_APP]: (state, app) => {
      state.selectedApp = app;
    },
    [CLEAR_SELECTED_APP]: state => {
      state.selectedApp = null;
    },
    [SET_APPS]: (state, apps) => {
      state.apps = apps;
    },
    [REMOVE_APP]: (state, appIndex) => {
      state.apps.splice(appIndex, 1);
    },
    /* ----------------------- */

    /*  Template building mutations */
    [SET_VIEWS]: (state, views) => {
      state.views = views;
    },
    [CLEAR_VIEWS]: state => {
      state.views = [];
    },
    [ADD_VIEW]: (state, view) => {
      state.views.push(view);
    },
    [SET_ADDED_VIEWTYPE]: (state, type) => {
      state.addedViewType = type;
    },
    [RESET_VIEWS_START]: state => {
      state.views.forEach(currentView => {
        currentView.start = false;
      });
    },
    /* ---------------- */

    [SET_FOOTER_STATE]: (state, stateId) => {
      state.footerState = stateId;
    },

    [SET_USER]: (state, user) => {
      // console.log(`Set user ${JSON.stringify(user)}`);
      state.user = user;
    },

    [SET_NAVIGATION_BAR_STATE]: (state, navstate) => {
      state.navigationBarState = navstate;
    },

    SET_DOWNLOAD_LINK: (state, link) => {
      state.appDownloadLink = link;
    },
    SET_PACKAGE_NAME: (state, name) => {
      state.appPackageName = name;
    },

    UPDATE_VIEW: (state, viewInfo) => {
      // clear all views from the start value if we're setting a new one
      state.views.forEach(currentView => {
        if (viewInfo.start === true) {
          currentView.start = false;
        }
      });

      state.views[viewInfo.index].name = viewInfo.name;
      state.views[viewInfo.index].fileName = viewInfo.fileName;
      state.views[viewInfo.index].type = viewInfo.type;
      state.views[viewInfo.index].start = viewInfo.start;
      state.selectedView = {};

      // Check if the update removed all starting views and set first view
      // to starting.
      var startingView = state.views.find(currentView => {
        return currentView.start === true;
      });

      if (startingView === undefined) {
        state.views[0].start = true;
      }
    },
    REMOVE_VIEW: (state, viewIndex) => {
      if (state.selectedView.name == state.views[viewIndex].name) {
        state.selectedView = { name: "" };
      }

      state.views.splice(viewIndex, 1);

      // Check if the update removed all starting views and set first view
      // to starting.
      var startingView = state.views.find(currentView => {
        return currentView.start === true;
      });

      if (startingView === undefined && state.views.length > 0) {
        state.views[0].start = true;
      }
    },
    CLEAR_APP_CONTENT: state => {
      state.views = [];
      state.selectedApp = null;
    },
    SET_SELECTED_APP_VIEW: (state, viewIndex) => {
      state.selectedView = state.views[viewIndex];
      state.selectedView.index = viewIndex;
    },
    CLEAR_SELECTED_VIEW: state => {
      state.selectedView = {};
    },

    IS_VIEW_SELECTED: (state, viewToCheck) => {
      return state.selectedView.name === viewToCheck.name;
    },
    SET_RESENDING_VERIFICATION: (state, value) => {
      state.resendingVerificationEmail = value;
    },
    UPDATE_NAVIGATION_BAR_STATE: (state, newState) => {
      state.navigationBarState = newState;
    }
  },
  actions: {
    /* Information actions */
    setSelectedTechnology: ({ commit }, technology) => {
      // Check if available
      if (technology.available === true) {
        // Clear technology
        commit(CLEAR_SELECTED_TECHNOLOGY);
        commit(SET_SELECTED_TECHNOLOGY, technology);
      }
    },
    setSelectedArchitecture: ({ commit }, architecture) => {
      if (architecture.available === true) {
        // Clear architectures
        commit(CLEAR_SELECTED_ARCHITECTURE);
        commit(SET_SELECTED_ARCHITECTURE, architecture);
        // set the available views from the architecture
      }
    },
    /* ------------------- */

    /* Dashboard app selection */
    setSelectedApp: ({ commit, getters }, app) => {
      // set the selected app
      commit(SET_SELECTED_APP, app);

      // set views for app details
      commit(SET_VIEWS, app.views);

      // set the selected architecture
      var appArchitecture = getters.getArchitectureFromValue(app.templateName);
      commit(SET_SELECTED_ARCHITECTURE, appArchitecture[0]);

      // set the selected technology
      var appTechnology = getters.getTechnologyFromValue(app.templateName);
      commit(SET_SELECTED_TECHNOLOGY, appTechnology);
    },
    /* ---------------- */

    /* Building template */
    addViewToTemplate: ({ commit, getters }, view) => {
      // Set added view type for logic in Dropdown.vue
      commit(SET_ADDED_VIEWTYPE, view.type);

      // Clear the start value from all the other views
      // if the new view has starting = true
      if (view.start === true) {
        commit(RESET_VIEWS_START);
      }

      // If there's no views in the state, set the current
      // view as starting
      if (!getters.hasTemplateViews) {
        view.start = true;
      }

      commit(ADD_VIEW, view);
    },
    /* ---------------- */

    /* User related actions */
    setUserState: ({ commit }, user) => {
      return new Promise((resolve, reject) => {
        commit(SET_USER, user);

        var navigationBarState = user != null ? 1 : 0;
        commit(SET_NAVIGATION_BAR_STATE, navigationBarState);
        resolve();
      });
    },
    /* ---------------- */

    setFooterState: ({ commit }, stateId) => {
      commit(SET_FOOTER_STATE, stateId);
    },
    clearSelections: ({ commit }) => {
      commit(CLEAR_SELECTED_TECHNOLOGY);
      commit(CLEAR_SELECTED_ARCHITECTURE);
      commit(CLEAR_SELECTED_APP);
      commit(CLEAR_VIEWS);
    },
    removeAppForUser: ({ commit }, appData) => {
      // TODO: Move all the firebase bits to a firestore module
      firebaseDb
        .collection("apps")
        .doc(appData.appId)
        .update({
          userId: ""
        });

      commit(REMOVE_APP, appData.appIndex);
    },
    generateAppTemplate: (context, templateInfo) => {
      context.commit("CLEAR_APP_CONTENT");

      context.commit("SET_DOWNLOAD_LINK", "");
      // console.log("Generate template info: " + JSON.stringify(templateInfo));
      Vue.axios.post(apiEndpoint + "/createtemplate", templateInfo).then(
        response => {
          // console.log("App Generation complete:" + response.data);
          context.commit("SET_DOWNLOAD_LINK", response.data);
          context.commit("CLEAR_APP_CONTENT");
        },
        error => {
          // console.log("Could not generate app: " + error);
          context.commit("SET_DOWNLOAD_LINK", {});
        }
      );
    },
    fetchUserApps: async ({ commit, state, dispatch }, user) => {
      if (user) {
        await dispatch("setUserState", user);
      }

      if (state.user) {
        firebaseDb
          .collection("apps")
          .where("userId", "==", state.user.email)
          .get()
          .then(snapShot => {
            var appsForUser = [];

            snapShot.forEach(doc => {
              var appData = doc.data();
              appsForUser.push({
                appId: doc.id,
                appDescription: appData.description,
                appName: appData.appName,
                packageName: appData.packageName,
                templateName: appData.templateName,
                androidProjectId: appData.androidProjectId,
                iosProjectId: appData.iosProjectId,
                views: appData.views
              });
            });
            commit(SET_APPS, appsForUser);
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    loginUser: ({ dispatch }, loginInfo) => {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signInWithEmailAndPassword(loginInfo.email, loginInfo.password)
          .then(user => {
            dispatch("setUserState", user);
            resolve();
          }, reject);
      });
    },
    signUpUser: ({ dispatch }, signUpInfo) => {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .createUserWithEmailAndPassword(signUpInfo.email, signUpInfo.password)
          .then(userCredential => {
            console.log(`User created: ${JSON.stringify(userCredential)}`);
            dispatch("setUserState", userCredential.user);
            return firebase
              .auth()
              .currentUser.sendEmailVerification()
              .then(function() {
                console.log(`Email sent`);
                // Email sent.
                resolve();
              })
              .catch(function(error) {
                // An error happened.
              });
          }, reject);
      });
    },
    performSocialLogin: ({ dispatch }) => {
      const provider = new firebase.auth.GoogleAuthProvider();

      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(userInformation => {
            dispatch("setUserState", userInformation.user);
            resolve();
          }, reject);
      });
    },
    signOutUser: ({ dispatch }) => {
      context.commit("CLEAR_SELECTED_VIEW");
      context.commit("CLEAR_APP_CONTENT");

      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signOut()
          .then(() => {
            dispatch("setUserState", null);
            resolve();
          }, reject);
      });
    },
    resendVerificationEmail: context => {
      context.commit("SET_RESENDING_VERIFICATION", true);
      firebase
        .auth()
        .currentUser.sendEmailVerification()
        .then(() => {
          context.commit("SET_RESENDING_VERIFICATION", false);
          console.log(`Email sent`);
        })
        .catch(function(error) {
          console.log(error.message);
        });
    }
  }
});
